exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-pagination-select-wrap{position:relative;display:inline-flex;align-items:center;z-index:20;margin-left:8px}.k-pagination-select{width:68px}html.dark .k-pagination-select .sb-global-dropdown__chevron{color:#e5e7eb}@media (prefers-color-scheme: dark){html:not(.light):not(.dark) .k-pagination-select .sb-global-dropdown__chevron{color:#e5e7eb}}\n", ""]);

// exports
